import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Icon from "./Icon";

const SITE_URL = "https://voorent.com";

// items: [{ label, to }] — the last item is the current page.
function Breadcrumb({ items }) {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      ...(item.to ? { item: `${SITE_URL}${item.to}` } : {}),
    })),
  };

  return (
    <nav className="v-crumbs" aria-label="Breadcrumb">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Helmet>
      <ol>
        {items.map((item, index) => {
          const last = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`}>
              {last || !item.to ? (
                <span aria-current={last ? "page" : undefined}>{item.label}</span>
              ) : (
                <Link to={item.to}>{item.label}</Link>
              )}
              {!last ? <Icon name="chevronRight" size={14} className="v-crumbs__sep" /> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumb;
